import * as moment from 'moment';
import {Dictionary} from './dictionary.model';
// import {FileItem} from './file.model';
import {Discount} from './discount.model';
import {Member} from './member.model';
import {Travel} from './travel.model';
import {Passport} from './passport.model';

export class Client {
  id: number;
  name: string;
  text: string;
  firstName: string;
  secondName: string;
  lastName: string;
  balance: {
    eur: number,
    usd: number,
    uah: number
  };
  birthday: any;
  travels: any;
  branch: Dictionary;
  manager: {
    id: number,
    firstName: string,
    lastName: string,
    name: string,
    text: string
  };
  sharedManager: {
    id: number,
    firstName: string,
    lastName: string,
    name: string,
    text: string
  } = {
    id: null,
    firstName: '',
    lastName: '',
    name: '',
    text: ''
  };
  passports: Passport[];
 // managerId: number;
  city: string;
  client: boolean;
  comment: string;
  discounts: Discount[];
  // files: FileItem[];
  folders: any;
  members: Member[];
  email: string;
  phone: string;
  disabled?: boolean;

  setFromApiModel(apiModel: any): this {

    this.id = apiModel.id;
    this.firstName = apiModel.first_name;
    this.secondName = apiModel.second_name;
    this.lastName = apiModel.last_name;
    if (apiModel.second_name) {
      this.name = `${apiModel.first_name} ${apiModel.second_name} ${apiModel.last_name}`;
      this.text = `${apiModel.first_name} ${apiModel.second_name} ${apiModel.last_name}`;
    } else {
      this.name = `${apiModel.first_name} ${apiModel.last_name}`;
      this.text = `${apiModel.first_name} ${apiModel.last_name}`;
    }
    this.balance = apiModel.balance;
    if (apiModel.birthday) {
      this.birthday = moment(apiModel.birthday);
    }

    // this.branch = new Dictionary().setFromApiModel(apiModel.branch);
    this.branch = apiModel.branch ? new Dictionary().setFromApiModel(apiModel.branch) : null;


   // this.managerId = apiModel.manager_id;
    this.manager = apiModel.manager ? {
      id: apiModel.manager.id,
      firstName: apiModel.manager.first_name,
      lastName: apiModel.manager.last_name,
      name: `${apiModel.manager.first_name} ${apiModel.manager.last_name}`,
      text: `${apiModel.manager.first_name} ${apiModel.manager.last_name}`
    } : null;
    if (apiModel.shared_manager) {
      this.sharedManager = {
        id: apiModel.shared_manager.manager_id,
        firstName: apiModel.shared_manager.first_name,
        lastName: apiModel.shared_manager.last_name,
        name: `${apiModel.shared_manager.first_name} ${apiModel.shared_manager.last_name}`,
        text: `${apiModel.shared_manager.first_name} ${apiModel.shared_manager.last_name}`
      };
    }

    this.city = apiModel.city;
    this.client = !!apiModel.client;
    this.comment = apiModel.comment;
    this.discounts = [];
    if (apiModel.discounts && apiModel.discounts.length) {
      apiModel.discounts.forEach((item) => {
        this.discounts.push(new Discount().setFromApiModel(item));
      });
    }


    // this.files = [];
    // this.folders = [];
    // if (apiModel.folders && apiModel.folders.length) {
    //   apiModel.folders.forEach((folder) => {
    //     let f = {
    //       id: folder.id,
    //       name: folder.name,
    //       files: [],
    //     }
    //
    //     if (folder.files.length) {
    //       folder.files.forEach(item => {
    //         f.files.push(new FileItem().setFromApiModel(item));
    //       })
    //     }
    //     this.folders.push(f);
    //   });
    // }

    this.passports = [];
    if (apiModel.passports && apiModel.passports.length) {
      apiModel.passports.forEach((item) => {
        this.passports.push(new Passport().setFromApiModel(item));
      });
    }

    this.members = [];
    this.travels = [];
    if (apiModel.travels) {
      apiModel.travels.forEach(item => {
        const travel = {
          id: item.id,
          packageName: item.package_name,
          dateFrom: moment(item.date_from),
          dateTo: moment(item.date_to),
          cost: item.cost,
          location: item.location,
          manager: item.manager
        };

        this.travels.push(travel);
      });
    }

    if (apiModel.members && apiModel.members.length) {
      apiModel.members.forEach((item) => {
        this.members.push(new Member().setFromApiModel(item));
      });
    }
    this.email = apiModel.email;
    this.phone = apiModel.phone;
    return this;
  }
}
